import type { CustomIconProps } from '../CustomIcon';

export const UserShareDeclinedIcon = ({
  color,
  secondaryColor,
  ternaryColor,
  solid,
  size = 24,
  ...props
}: CustomIconProps) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox='0 0 25 25'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}>
      <path
        d='M17 21V19C17 17.9391 16.5786 16.9217 15.8284 16.1716C15.0783 15.4214 14.0609 15 13 15H6C4.93913 15 3.92172 15.4214 3.17157 16.1716C2.42143 16.9217 2 17.9391 2 19V21'
        stroke={color}
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
        fill={color}
      />
      <path
        d='M23 11H17M17 11L19 9M17 11L19 13'
        stroke={secondaryColor}
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M18 6L24 6M24 6L22 8M24 6L22 4'
        stroke={secondaryColor}
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M9.5 11C11.7091 11 13.5 9.20914 13.5 7C13.5 4.79086 11.7091 3 9.5 3C7.29086 3 5.5 4.79086 5.5 7C5.5 9.20914 7.29086 11 9.5 11Z'
        stroke={color}
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
        fill={color}
      />
      <rect x='0.5' y='13.5' width='11' height='11' rx='5.5' fill='#D8601E' />
      <rect x='0.5' y='13.5' width='11' height='11' rx='5.5' stroke='white' />
      <path
        d='M8 17L4 21'
        stroke='white'
        strokeWidth='1.25'
        strokeLinecap='square'
        strokeLinejoin='round'
      />
      <path
        d='M4 17L8 21'
        stroke='white'
        strokeWidth='1.25'
        strokeLinecap='square'
        strokeLinejoin='round'
      />
    </svg>
  );
};
